var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramStage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 28,
    viewBox: "0 0 220 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_15458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 28H24.5009V3.49906H3.49906V28H0V0H28V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0018 27.9996H17.5028V11.0235H10.4971V27.9996H6.99805V7.52441H21.0018V27.9996Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_15458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5579 1.6084H63.3877V26.3848H67.5579V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9231 1.6084H74.7529V26.3848H78.9231V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5795 11.2157L64.8018 15.2344L66.1484 19.1812L77.9262 15.1625L76.5795 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6487 1.6416H44V5.81181H58.6487V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4124 3.72656H49.2422V26.3582H53.4124V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8176 28L81.8096 13.1461L90.984 0L94.3996 2.38298L86.9396 13.0733L96.167 25.5177L92.8176 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4923 11.0283H84.3779V15.1985H94.4923V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_15458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.376 27.4838L165.771 15.4299L165.698 12.9277L174.469 0.509766L177.871 2.91922L170.001 14.053L176.806 22.592L180.963 15.9726L176.746 16.3102L176.415 12.1533L184.775 11.4913L186.702 14.6753L178.772 27.2984L175.376 27.4838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.256 26.339L154.961 8.70492L149.011 26.3059L145.065 24.9754L152.929 1.69499L154.67 1.67513L156.868 1.65527L165.182 24.9357L161.256 26.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.022 19.1329L155.129 16.2402L152.236 19.1329L155.129 22.0255L158.022 19.1329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.245 27.371L113.683 24.0878L119.574 19.4873L112.167 10.4585L121.785 0.62207L124.764 3.54122L117.754 10.7034L125.498 20.1493L116.245 27.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57 1.6416H128.921V5.81181H143.57V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.333 3.72656H134.163V26.3582H138.333V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.391 28L187.383 13.1461L196.557 0L199.973 2.38298L192.519 13.0733L201.74 25.5177L198.391 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.066 11.0283H189.951V15.1985H200.066V11.0283Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_15458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_15458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_15458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.5735,
    height: 28,
    fill: "white",
    transform: "translate(112.167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramStage);
export default __webpack_public_path__ + "static/media/programStage.923cb1fbde1cbd02263918f1acaba11e.svg";
export { ForwardRef as ReactComponent };